<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <template v-if="localComunicado?.tipo === 2">
                <b-col cols="12" class="mb-3">
                    <Button @click="showModal('como-funciona')">¿Cómo funciona?</Button>
                </b-col>
                <ModalComponent
                    name="como-funciona"
                    title="¿Cómo funciona?"
                    @close="closeModal('como-funciona')"
                >
                    <h4>
                        Para crear las plantillas que podréis seleccionar desde el selector de más abajo, se crean desde el siguiente enlace
                        <router-link :to="{ name: 'back.plantillas-whatsapp.crear' }" target="_blank" class="blue">
                            <span>Crear plantillas</span>
                        </router-link>.
                    </h4>
                    <h4>Una vez ahí, rellenarás los datos del formulario y verás una vista prevía a la derecha de cómo va quedando el mensaje que se enviará por WhatsApp, al igual que la ves justo debajo del selector de la plantilla.</h4>
                </ModalComponent>
            </template>
            <b-col cols="12" class="mb-2">
                <div class="form-group">
                    <label for="tipo-comunicado">Selecciona el tipo de comunicado:</label>
                    <ValidationProvider name="tipo-comunicado" rules="required" v-slot="{ errors }">
                        <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="tipo-comunicado" v-model="localComunicado.tipo">
                            <option :value="0" selected>Selecciona el tipo de comunicado</option>
                            <option :value="1">Email</option>
                            <option :value="2">WhatsApp</option>
                        </select>
                        <span v-if="errors[0]" class="p-2 mb-4 text-xs d-block invalid-feedback bg-danger white h7 font-weight-bold">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
            </b-col>
            <b-col v-if="localComunicado.tipo > 0" cols="12">
                <FormEmail
                    v-if="localComunicado.tipo == 1"
                    ref="formEmail"
                    :comunicado="localComunicado"
                    :loading.sync="loading"
                />
                <FormWhatsapp v-else-if="localComunicado.tipo == 2" :comunicado="localComunicado" :loading.sync="loading" />

                <b-col cols="12" class="pr-0 mt-3 text-right">
                    <Button type="submit" name="button" :disabled="loading">CONTINUAR</Button>
                </b-col>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
    import FormEmail from '@/components/backend/comunicados/tipo-comunicado/FormEmail.vue';
    import FormWhatsapp from '@/components/backend/comunicados/tipo-comunicado/FormWhatsapp.vue';
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: {
            comunicado: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                localComunicado: this.normalizeComunicado(this.comunicado),
            }
        },
        watch: {
            comunicado: {
                immediate: false,
                handler(value) {
                    this.localComunicado = this.normalizeComunicado(value);
                }
            }
        },
        methods: {
            normalizeComunicado(comunicado = {}) {
                return {
                    ...comunicado,
                    listo_para_enviar: comunicado.listo_para_enviar == 1 ? 1 : 0
                };
            },
            buildPayload(comunicado = this.localComunicado) {
                const payload = {
                    ...comunicado
                };

                if (payload.whatsapp_template) {
                    payload.whatsapp_template_id = payload.whatsapp_template.id;
                    delete payload.whatsapp_template;
                }

                if (!payload.whatsapp_template_id) {
                    delete payload.whatsapp_template_id;
                }

                if (payload.base) {
                    payload.base_id = payload.base.id;
                    delete payload.base;
                }

                return payload;
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if(isValid) {
                    let comunicado = this.localComunicado;

                    if (this.localComunicado.tipo == 1 && this.$refs.formEmail) {
                        comunicado = this.$refs.formEmail.procesarEditoresQuill();
                    }

                    this.$emit('terminado', this.buildPayload(comunicado));
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
        },
        components: {
            FormEmail, FormWhatsapp, ModalComponent
        }
    }
</script>
